import React from 'react';

interface FilterIconProps {
  color?: string;
  width?: string;
  height?: string;
  isActive?: boolean;
  className?: string;
}

const FilterIcon: React.FC<FilterIconProps> = ({
  color = 'currentColor',
  width = '22px',
  height = '26px',
  isActive = false,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* First slider bar */}
      <g>
        {/* Bar line */}
        <path
          d="M0.150499 6.88281H20.8971C20.9799 6.88281 21.0476 6.81508 21.0476 6.7323C21.0476 6.64953 20.9799 6.58179 20.8971 6.58179H0.150499C0.0677233 6.58179 0 6.64953 0 6.7323C0 6.81508 0.0677233 6.88281 0.150499 6.88281Z"
          fill={color}
        />
        {/* Ball - animates from 20% to 70% */}
        <g
          className="filter-ball-1"
          style={{
            transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            transform: isActive ? 'translateX(8.95px)' : 'translateX(0)',
          }}
        >
          <circle
            cx="5.74915"
            cy="6.7323"
            r="2.15535"
            fill={!isActive ? 'white' : 'black'}
            stroke={color}
            strokeWidth="0.4"
          />
        </g>
      </g>

      {/* Second slider bar */}
      <g>
        {/* Bar line */}
        <path
          d="M0.150499 13.1894H20.8971C20.9799 13.1894 21.0476 13.1217 21.0476 13.0389C21.0476 12.9562 20.9799 12.8884 20.8971 12.8884H0.150499C0.0677233 12.8884 0 12.9562 0 13.0389C0 13.1217 0.0677233 13.1894 0.150499 13.1894Z"
          fill={color}
        />
        {/* Ball - animates from 80% to 20% */}
        <g
          className="filter-ball-2"
          style={{
            transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            transform: isActive ? 'translateX(-11.15px)' : 'translateX(0)',
          }}
        >
          <circle
            cx="15.3511"
            cy="13.0389"
            r="2.15535"
            fill={!isActive ? 'white' : 'black'}
            stroke={color}
            strokeWidth="0.4"
          />
        </g>
      </g>

      {/* Third slider bar */}
      <g>
        {/* Bar line */}
        <path
          d="M0.150499 19.4199H20.8971C20.9799 19.4199 21.0476 19.3522 21.0476 19.2694C21.0476 19.1866 20.9799 19.1189 20.8971 19.1189H0.150499C0.0677233 19.1189 0 19.1866 0 19.2694C0 19.3522 0.0677233 19.4199 0.150499 19.4199Z"
          fill={color}
        />
        {/* Ball - animates from 40% to 50% */}
        <g
          className="filter-ball-3"
          style={{
            transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            transform: isActive ? 'translateX(3px)' : 'translateX(0)',
          }}
        >
          <circle
            cx="9.158"
            cy="19.2694"
            r="2.15535"
            fill={!isActive ? 'white' : 'black'}
            stroke={color}
            strokeWidth="0.4"
          />
        </g>
      </g>
    </svg>
  );
};

export default FilterIcon;
